"use client";
import contactDetailsBg from "@/assets/landingPage/contact/contact-details-bg.png";
import contactFormBg from "@/assets/landingPage/contact/contact-form-bg.png";
import ApiPath from "@/network/api/apiPath";
import NetworkService from "@/network/service/networkService";
import { Icon } from "@iconify/react";
import Image from "next/image";
import { useState } from "react";
import { toast } from "react-toastify";
import SectionReveal from "../animation/SectionReveal";
import TextReveal from "../animation/TextReveal";
import PageHeader from "../shared/PageHeader";

const ContactUs = ({ pageData }) => {
  const network = new NetworkService();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleContactUs = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await network.globalPost(ApiPath.contactUs, {
        name: name,
        email: email,
        subject: subject,
        msg: message,
      });
      if (res.status === "completed") {
        toast.success("Message sent successfully!");
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="overflow-hidden">
      <TextReveal delay={0.2} duration={1.2} direction="left">
        <PageHeader title={pageData?.page?.name} />
      </TextReveal>

      <SectionReveal delay={0.3}>
        <div className="section_space_py">
          <div className="custom-container mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7.5">
              <div
                className="bg-cover bg-no-repeat w-full h-full outer-box-shadow-two rounded-[12px] p-5 xl:p-7.5 border border-[rgba(45,45,45,0.06)]"
                style={{ backgroundImage: `url(${contactDetailsBg.src})` }}
              >
                <div className="flex flex-col items-center gap-3 md:gap-5">
                  <div className="w-[40px] md:w-[50px] h-[40px] md:h-[50px]">
                    <Image
                      src={pageData?.page?.data?.address_icon}
                      alt="icon"
                      width={100}
                      height={100}
                      unoptimized
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h4 className="text-[18px] md:text-[20px] font-bold text-user-text">
                    {pageData?.page?.data?.address_label}
                  </h4>
                  <p className="text-[15px] font-medium text-user-paragraph text-center">
                    {pageData?.page?.data?.address}
                  </p>
                </div>
              </div>

              <div
                className="bg-cover bg-no-repeat w-full h-full outer-box-shadow-two rounded-[12px] p-5 xl:p-7.5 border border-[rgba(45,45,45,0.06)]"
                style={{ backgroundImage: `url(${contactDetailsBg.src})` }}
              >
                <div className="flex flex-col items-center gap-3 md:gap-5">
                  <div className="w-[40px] md:w-[50px] h-[40px] md:h-[50px]">
                    <Image
                      src={pageData?.page?.data?.email_icon}
                      alt="icon"
                      width={100}
                      height={100}
                      unoptimized
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h4 className="text-[18px] md:text-[20px] font-bold text-user-text">
                    {pageData?.page?.data?.email_label}
                  </h4>
                  <p className="text-[15px] font-medium text-user-paragraph text-center">
                    {pageData?.page?.data?.email}
                  </p>
                </div>
              </div>

              <div
                className="bg-cover bg-no-repeat w-full h-full outer-box-shadow-two rounded-[12px] p-5 xl:p-7.5 border border-[rgba(45,45,45,0.06)]"
                style={{ backgroundImage: `url(${contactDetailsBg.src})` }}
              >
                <div className="flex flex-col items-center gap-3 md:gap-5">
                  <div className="w-[40px] md:w-[50px] h-[40px] md:h-[50px]">
                    <Image
                      src={pageData?.page?.data?.phone_icon}
                      alt="icon"
                      width={100}
                      height={100}
                      unoptimized
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h4 className="text-[18px] md:text-[20px] font-bold text-user-text">
                    {pageData?.page?.data?.phone_no_label}
                  </h4>
                  <p className="text-[15px] font-medium text-user-paragraph text-center">
                    {pageData?.page?.data?.phone_no}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionReveal>

      <SectionReveal delay={0.4}>
        <div className="section_space_pB">
          <div className="custom-container mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-7.5">
              <div
                className="bg-cover bg-no-repeat w-full h-full rounded-[12px] p-5 xl:p-7.5 border border-[rgba(45,45,45,0.06)]"
                style={{ backgroundImage: `url(${contactFormBg.src})` }}
              >
                <div className="mb-5 sm:mb-10 xl:mb-[60px] flex flex-col justify-center items-center">
                  <h2 className="text-[22px] sm:text-[24px] md:text-[30px] xl:text-[40px] font-semibold text-user-text  mb-2 sm:mb-4 text-center">
                    Contact Information
                  </h2>
                  <p className="text-[15px] font-medium text-user-paragraph text-center">
                    Say something to start a live chat!
                  </p>
                </div>
                <form onSubmit={handleContactUs}>
                  <div className="grid grid-cols-12 gap-3.5 sm:gap-5">
                    <div className="col-span-12">
                      <label htmlFor="your-name" className="user-label">
                        Your Name <span className="text-user-error">*</span>
                      </label>
                      <div>
                        <div className="relative">
                          <input
                            type="text"
                            id="your-name"
                            name="your-name"
                            className={`user-input user-input-right peer`}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                          <div className="icon absolute rtl:left-4 ltr:right-4 top-1/2 -translate-y-1/2 text-[rgba(45,45,45,0.44)] peer-focus:text-[rgba(116,69,255,0.60)]">
                            <Icon
                              icon="basil:user-solid"
                              width="20"
                              height="20"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-12">
                      <label htmlFor="email" className="user-label">
                        Email <span className="text-user-error">*</span>
                      </label>
                      <div>
                        <div className="relative">
                          <input
                            type="email"
                            id="email"
                            name="email"
                            className={`user-input user-input-right peer`}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <div className="icon absolute rtl:left-4 ltr:right-4 top-1/2 -translate-y-1/2 text-[rgba(45,45,45,0.44)] peer-focus:text-[rgba(116,69,255,0.60)]">
                            <Icon
                              icon="basil:envelope-solid"
                              width="20"
                              height="20"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-12">
                      <label htmlFor="subject" className="user-label">
                        Your Subject <span className="text-user-error">*</span>
                      </label>
                      <div>
                        <div className="relative">
                          <input
                            type="text"
                            id="subject"
                            name="subject"
                            className={`user-input peer`}
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-span-12">
                      <label htmlFor="subject" className="user-label">
                        Your Message <span className="text-user-error">*</span>
                      </label>
                      <div>
                        <div className="relative">
                          <textarea
                            className="user-textarea"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-span-12">
                      <button
                        className="group primary-button w-full"
                        type="submit"
                        disabled={loading}
                      >
                        <span className="primary-button-hover-effect"></span>
                        <span className="primary-button-text">
                          {loading ? "Sending..." : "Send Message"}
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div>
                <div className="h-[300px] sm:h-[500px] md:h-[700px] xl:h-[745px] w-full">
                  <Image
                    src={pageData?.page?.data?.form_right_image}
                    alt="contact form"
                    width={1000}
                    height={1000}
                    className="w-full h-full object-cover rounded-2xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionReveal>
    </div>
  );
};

export default ContactUs;
